
const LIVE_URL = "https://api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";
export const MAIN_URL = LIVE_URL
export const APPLICATION_KEY = "ems";

/** Socket.io realtime server (separate from Laravel API). */
export const SOCKETIO_URL =
  // process.env.REACT_APP_SOCKETIO_URL || "http://127.0.0.1:4001";
  process.env.REACT_APP_SOCKETIO_URL ||
  "https://notifications.nsplprojects.com";
/** Headers for fetch() calls (axios interceptor does not apply to fetch). */
export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  try {
    const workspace = localStorage.getItem("ems.activeWorkspace");
    if (workspace && !headers["X-EMS-Workspace"]) {
      headers["X-EMS-Workspace"] = workspace;
    }
  } catch {
    // ignore storage access
  }
  return headers;
}